import React from 'react';
const BONUSES = [{
  id: 1,
  title: 'Bono 1: Guía de hábitos sanos',
  img: 'https://cdn.magicpatterns.com/uploads/bpPzgbywkuydxT26N5Ftyx/ChatGPT_Image_31_ene_2026,_01_43_40_a.m..png'
}, {
  id: 2,
  title: 'Bono 2: Concentración sin celular',
  img: 'https://cdn.magicpatterns.com/uploads/irycKi2kxsdtDC2iYZi5ec/ChatGPT_Image_31_ene_2026,_01_44_35_a.m..png'
}, {
  id: 3,
  title: 'Bono 3: Actividades familiares',
  img: 'https://cdn.magicpatterns.com/uploads/mPb5VQAxNGDie68XWbqBcR/ChatGPT_Image_31_ene_2026,_01_45_17_a.m..png'
}];
interface BonusesProps {
  onScrollToPrice: () => void;
}
export function Bonuses({
  onScrollToPrice
}: BonusesProps) {
  return <section className="py-16 bg-gray-50 px-4" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-22">
            Regalos incluidos hoy
          </h2>
          <p className="text-gray-500" data-id="element-23">
            Herramientas extra para potenciar tus resultados (Sin costo
            adicional)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-24">
          {BONUSES.map(bonus => <div key={bonus.id} className="flex flex-col items-center cursor-pointer group" onClick={onScrollToPrice} data-id="element-25">
              <div className="bg-white p-2 rounded-xl shadow-sm border border-gray-100 mb-4 group-hover:-translate-y-1 transition-transform duration-300 w-full max-w-[300px]" data-id="element-26">
                <img src={bonus.img} alt={bonus.title} className="w-full h-auto rounded-lg object-contain" data-id="element-27" />
              </div>
              <p className="font-semibold text-gray-800 text-center group-hover:text-red-600 transition-colors" data-id="element-28">
                {bonus.title}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}